import { render } from "./Page.vue?vue&type=template&id=447242d8&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=447242d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-447242d8"

export default script